import Bee from '@mailupinc/bee-plugin';
import Bugsnag from '@bugsnag/js';
import dynamicContentUtils from '../components/dynamic-contents/dynamicContentUtils.js';
import {translate as t} from '../i18n';

const parseContents = dynamicContentUtils().parseContents;

export const actions = {
  USE: 'use',
  EXPORT: 'export',
  SAVE: 'save'
};

function mapCategories(categories) {
  return categories.map(cat => ({
    handle: cat.id,
    value: cat.id,
    name: cat.name,
    isLocal: true,
    behaviors: {
      canEdit: true,
      canDelete: true
    }
  }));
}

export default function () {
  let bee;
  let templateData;
  let conf;
  let action;
  let useAction;
  let exportAction;
  let saveAction;
  let sendAction;

  const showDisplayConditions = (conf, showDisplayConditionsCallback) => {
    const label = t('filters.button_label');
    conf.contentDialog.rowDisplayConditions = {
      label,
      handler: function (resolve, reject) {
        showDisplayConditionsCallback(resolve, reject);
      }
    };
  };

  const showDynamicContents = (conf, showDynamicContentsCallback) => {
    const label = t('content.add_content_btn');
    conf.contentDialog.mergeContents = {
      label,
      handler: function (resolve, reject) {
        showDynamicContentsCallback(resolve, reject);
      }
    };
  };

  return {
    initialize: (
      retrievedTemplate,
      showDisplayConditionsCallback,
      showDynamicContentsCallback,
      showExternalContentUrlsCallback,
      showSaveRowDialogCallback,
      getRowsCallback,
      deleteRowDialogCallback
    ) => {
      templateData = retrievedTemplate;
      conf = templateData.conf;
      conf.contentDialog = {
        saveRow: {
          handler: showSaveRowDialogCallback
        },
        onDeleteRow: {
          handler: deleteRowDialogCallback
        },
        onEditRow: {
          handler: async (resolve, reject, args) => {
            showSaveRowDialogCallback(resolve, reject, args.row, true);
          }
        },
        externalContentURLs: {
          label: t('row_categories.container_title'),
          handler: showExternalContentUrlsCallback
        }
      };
      conf.rowsConfiguration = {
        emptyRows: true,
        defaultRows: false,
        isChunked: true,
        chunkPageInterval: 2000,
        externalContentURLs: mapCategories(conf.savedRowCategories)
      };
      if (templateData.mergeTagsSource !== undefined) {
        showDisplayConditions(conf, showDisplayConditionsCallback);
      }
      if (conf.mergeContents !== undefined) {
        parseContents(conf.mergeContents);
        showDynamicContents(conf, showDynamicContentsCallback);
      }
      conf.onSend = html => {
        sendAction(html);
      };
      conf.onSaveAsTemplate = () => {
        action = actions.SAVE;
        bee.save();
      };
      conf.onSave = (json, html) => {
        if (!json) {
          Bugsnag.notify(new Error('Retrieved an invalid json from Bee'));
        }
        switch (action) {
          case actions.USE:
            useAction(json, html);
            break;
          case actions.EXPORT:
            exportAction(json, html);
            break;
          case actions.SAVE:
            saveAction(json, html);
            break;
        }
      };
      conf.hooks = {
        getRows: {
          handler: getRowsCallback
        }
      };
      bee = new Bee(JSON.parse(templateData.token));
    },
    setAction: selectedAction => {
      action = selectedAction;
    },
    setUseAction: pUseAction => {
      useAction = pUseAction;
    },
    setExportAction: pExportAction => {
      exportAction = pExportAction;
    },
    setSaveAction: pSaveAction => {
      saveAction = pSaveAction;
    },
    setTrackChanges: trackChanges => {
      conf.trackChanges = true;
      conf.onChange = trackChanges;
    },
    setSendAction: pSendAction => {
      sendAction = pSendAction;
    },
    start: () => bee.start(conf, JSON.parse(templateData.template)),
    continue: template => bee.start(conf, JSON.parse(template)),
    retrieveTemplate: () => {
      action = actions.USE;
      bee.save();
    },
    exportTemplate: () => {
      action = actions.EXPORT;
      bee.save();
    },
    resetExternalContentUrls: categories => {
      const externalContentUrls = mapCategories(categories);
      conf.rowsConfiguration.externalContentURLs = externalContentUrls;
      bee.loadConfig(conf);
    }
  };
}
